<template>
  <v-btn v-if="visible" text :title="$t('whatsapp')" :to="{ name: 'whatsapp' }">
    <v-badge
      :content="String(unread)"
      :value="unread > 0"
      color="green"
      overlap
    >
      <v-img
        :src="require('@/assets/new-icons/whatsapp.svg')"
        height="30"
        width="30"
      />
    </v-badge>
  </v-btn>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'inbox-badge',
  data() {
    return {
      unread: 0
    }
  },
  computed: {
    ...mapGetters({
      me: 'session/me',
      company: 'company/getCompanyData',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      lastEvent: 'whatsapp/getLastEvent'
    }),
    visible() {
      if (!this.me || !this.company) {
        return false
      }
      return (
        this.isAdmin ||
        this.getPermissions([
          'whatsapp.view_inbox',
          'whatsapp.view_conversation'
        ])
      )
    }
  },
  methods: {
    /**
     * Cuenta las conversaciones con mensajes sin leer.
     * Se pide un solo registro: lo que interesa es el total que devuelve la
     * paginación, no las conversaciones en sí.
     */
    async load() {
      if (!this.visible) {
        return
      }
      try {
        const response = await this.$api.whatsapp.list({
          opt: {
            params: {
              company_id: this.company.pk,
              unread: 'true',
              size: 1
            },
            skipErrorToast: true
          }
        })
        this.unread =
          response.data.count !== undefined
            ? response.data.count
            : response.data.length
      } catch (e) {
        // El contador es accesorio: si falla, no molesta al usuario
      }
    }
  },
  watch: {
    // La bandeja avisa por su propio socket cuando está abierta
    lastEvent() {
      this.load()
    },
    $route() {
      this.load()
    }
  },
  mounted() {
    this.load()

    // Fuera de la bandeja, quien se entera es la campana: usa el socket de
    // notificaciones, que ya está conectado en toda la aplicación. Así el
    // contador se actualiza sin mantener un sondeo propio.
    this.$root.$on('whatsapp-notification', this.load)
  },
  beforeDestroy() {
    this.$root.$off('whatsapp-notification', this.load)
  }
}
</script>
